import React from "react";
import { useHistory } from "react-router-dom";
import Modal from "../../../../shared/components/Modal/Modal";
import "./AdaptiveUpgradeModal.css";

const upgradeFeatureList = [
  "Detailed solutions",
  "Custom topic practice",
  "Full mastery tracking",
  "Unlimited Focus Sets",
];

const AdaptiveUpgradeModal = ({ isOpen, onClose, onCtaClick }) => {
  const history = useHistory();

  const handleCtaClick = () => {
    if (typeof onCtaClick === "function") {
      onCtaClick();
      return;
    }
    onClose?.();
    history.push("/packages");
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="564px"
      height="486px"
      backgroundColor="transparent"
      boxShadow="none"
      borderRadius="16px"
      marginTop="0"
      closeButtonStyle={{ top: "calc(50% - 260px)", left: "50%" }}
    >
      <div className="aqb-upgrade-modal">
        <div className="aqb-upgrade-modal__offer">Limited time offer</div>
        <h3 className="aqb-upgrade-modal__title">Adaptive Question Bank</h3>
        <div className="aqb-upgrade-modal__price-wrap">
          <div className="aqb-upgrade-modal__price-row">
            <span className="aqb-upgrade-modal__price">Rs 1,499</span>
            <span className="aqb-upgrade-modal__term">/year</span>
          </div>
          <div className="aqb-upgrade-modal__discount-row">
            <span className="aqb-upgrade-modal__old-price">Rs 2,999</span>
            <span className="aqb-upgrade-modal__discount-chip">50% OFF</span>
          </div>
        </div>
        <div className="aqb-upgrade-modal__separator" />
        <p className="aqb-upgrade-modal__subtitle">
          Upgrade to continue practicing without limits and access:
        </p>
        <div className="aqb-upgrade-modal__features">
          {upgradeFeatureList.map((feature) => (
            <div key={feature} className="aqb-upgrade-modal__feature">
              <span className="aqb-upgrade-modal__feature-icon">✓</span>
              <span>{feature}</span>
            </div>
          ))}
        </div>
        <button type="button" className="aqb-upgrade-modal__cta" onClick={handleCtaClick}>
          Unlock Unlimited Practice
        </button>
      </div>
    </Modal>
  );
};

export default AdaptiveUpgradeModal;
